import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { injectLocal, provideLocal } from '@vueuse/core';
import { useBagContext } from '@modules/add-to-bag/composables/useBagContext';
import { PRODUCT_QUANTITY_REPOSITORY } from '../constants';
import { useProduct } from './useProduct';

/**
 * * Quantity Composable
 * @returns {{
 * quantity: import('vue').Ref<number>,
 * minQuantity: number,
 * maxQuantity: number,
 * isQuantityEnabled: boolean,
 * }}
 */
export const useQuantity = () => injectLocal(PRODUCT_QUANTITY_REPOSITORY);

export const useQuantityProvide = () => {
  const { query } = useRoute();
  const { productData } = useProduct();
  const { isUpdateBagEnabled } = useBagContext();

  const initialQuantity = (isUpdateBagEnabled && query?.Quantity) ? Number.parseInt(query?.Quantity, 10) : 1;

  /**
   * * Minimum quanitity value
   */
  const minQuantity = 1;
  /**
   * * Maximum quanity value
   */
  const maxQuantity = productData?.detail?.maxQuantity || 6;

  /**
   * * Inner quantity value
   *
   * Initial value based on
   */
  const quantityValue = ref(initialQuantity);

  const quantity = computed({
    get() {
      return quantityValue.value;
    },
    set(value) {
      quantityValue.value = Math.min(Math.max(value, minQuantity), maxQuantity);
    },
  });

  provideLocal(PRODUCT_QUANTITY_REPOSITORY, {
    quantity,
    minQuantity,
    maxQuantity,
  });
};
